import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/admin/merchant/soap/diagnose/selfList',
    method: 'post',
    data,
    showLoading: true // 可以控制是否显示加载提示
  })
}
// 获取云通信登录信息
export function getlogin(data) {
  return request({
    url: '/admin/merchant/soap/diagnose/loginSml',
    method: 'post',
    data,
    showLoading: true // 可以控制是否显示加载提示
  })
}
//获取会员信息
export function getMember(params) {
  return request({
    url: '/admin/merchant/soap/diagnose/contact',
    method: 'get',
    params: params
  })
}
//获取处方信息
export function getCf(params) {
  return request({
    url: '/admin/merchant/soap/diagnose/selfList',
    method: 'get',
    params: params
  })
}
//保存图片
export function saveimg(data) {
  return request({
    url: '/admin/merchant/soap/diagnose/saveContact',
    method: 'post',
    data,
    showLoading: true // 可以控制是否显示加载提示
  })
}

//自主处方问诊
export function saveContact(data) {
  return request({
    url: '/admin/merchant/soap/diagnose/saveNewContact',
    method: 'post',
    data,
    showLoading: true // 可以控制是否显示加载提示
  })
}

//获取药师
export function getPharmOnline(params) {
  return request({
    url: '/admin/merchant/soap/pharm/getPharmOnline',
    method: 'get',
    params: params
  })
}
//批量推送消息
export function sendMode(data) {
  return request({
    url: '/admin/merchant/wy/im/sendMode',
    method: 'post',
    data,
    showLoading: true // 可以控制是否显示加载提示
  })
}
//获取人员信息
export function imUserApi(data) {
  return request({
    url: '/admin/merchant/wy/im/getUinfos',
   method: 'post',
    data,
    showLoading: true // 可以控制是否显示加载提示
  })
}
//发送单条消息
export function imSendMessageApi(data) {
  return request({
    url: '/admin/merchant/wy/im/sendInfo',
    method: 'post',
    data,
    showLoading: true // 可以控制是否显示加载提示
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

//获取当前门店580处方列表
export function getCurrList(params) {
  return request({
    url: '/admin/merchant/soap/diagnose/currList',
    method: 'get',
    params: params
  })
}

//获取当前门店处方统计
export function getStatistics(params) {
  return request({
    url: '/admin/merchant/soap/diagnose/examineInfo',
    method: 'get',
    params: params
  })
}


//获取消息列表
export function getPresLog(params) {
  return request({
    url: '/admin/merchant/soap/diagnose/presLog',
    method: 'get',
    params: params,
    showLoading:false,
  })
}

export function readStatus(data) {
  return request({
    url: '/admin/merchant/soap/diagnose/readStatus',
    method: 'post',
    data,
  })
}

// 轮询消息 
export function getOneLog(params) {
  return request({
    url: '/admin/merchant/soap/diagnose/oneLog',
    method: 'get',
    params: params,
    showLoading:false,
  })
}

// 获取审核列表
export function getMtList(params) {
  return request({
    url: '/admin/merchant/soap/diagnose/mtList',
    method: 'get',
    params: params,
  })
}

// 获取审核视频
export function imHisRecordApi(data) {
  return request({
    url: '/admin/merchant/wy/im/hisRecord',
    method: 'post',
    data,
  })
}

// 创建云端录制
export function imCreateRecordApi(data) {
  return request({
    url: '/admin/merchant/wy/im/createRecord',
    method: 'post',
    data,
    showLoading:false,
  })
}

// 查看处方详情
export function diagnoseRecipelSingleApi(params) {
  return request({
    url: '/admin/merchant/soap/diagnose/recipelSingle',
    method: 'get',
    params,
  })
}

// 药师列表及排队数量
export function getPharmListWithQueue(params) {
  return request({
    url: '/admin/merchant/soap/pharm/listWithQueue',
    method: 'get',
    params,
  })
}

// 开始审方（入队）
export function joinQueueApi(data) {
  return request({
    url: '/admin/merchant/soap/pharm/joinQueue',
    method: 'post',
    data,
  })
}

// 查询排队位置
export function getQueuePosition(params) {
  return request({
    url: '/admin/merchant/soap/pharm/queuePosition',
    method: 'get',
    params,
    showLoading: false,
  })
}

// 取消排队
export function queueCancelApi(data, config = {}) {
  return request({
    url: '/admin/merchant/soap/pharm/queueCancel',
    method: 'post',
    data,
    ...config,
  })
}

// 确认审方（轮到后1分钟内必须调用）
export function confirmReviewApi(data) {
  return request({
    url: '/admin/merchant/soap/pharm/confirmReview',
    method: 'post',
    data,
    showLoading: false,
  })
}

